{
	"filters": "Suodattimet",
	"manufacturer": "Valmistaja",
	"discModel": "Kiekkomalli",
	"plastic": "Muovi",
	"discClass": "Kiekkotyyppi",
	"condition": "Kunto",
	"color": "Väri",
	"flight": "Lennot",
	"price": "Hinta",
	"weight": "Paino",
	"shipsTo": "Toimitus",
	"country": "Maa",
	"distance": "Etäisyys",
	"distanceNoLocation": "Aseta kaupunkisi Asetuksissa käyttääksesi etäisyyssuodatinta",
	"clearAll": "Tyhjennä kaikki",
	"searchPlaceholder": "Hae kiekkoja...",
	"clearSearch": "Tyhjennä haku",
	"searchListings": "Hae ilmoituksia",
	"discClasses": {
		"putter": "Putteri",
		"midrange": "Midrange",
		"fairway-driver": "Fairway-draiveri",
		"distance-driver": "Distance-draiveri"
	},
	"conditions": {
		"9": "Kuin uusi",
		"8": "Erinomainen",
		"7": "Hyvä",
		"6": "Kohtalainen",
		"5": "Kulunut",
		"1-3": "Rähjäinen"
	},
	"colors": {
		"Beige": "Beige",
		"Black": "Musta",
		"Blue": "Sininen",
		"Green": "Vihreä",
		"Grey": "Harmaa",
		"Orange": "Oranssi",
		"Pink": "Vaaleanpunainen",
		"Purple": "Violetti",
		"Red": "Punainen",
		"Silver": "Hopea",
		"Transparent": "Läpinäkyvä",
		"Turquoise": "Turkoosi",
		"White": "Valkoinen",
		"Yellow": "Keltainen",
		"Dyed": "Värjätty"
	},
	"shipsToOptions": {
		"pickup-only": "Vain nouto",
		"domestic": "Kotimaa",
		"international": "Kansainvälinen"
	},
	"flightNumbers": {
		"speed": "Nopeus",
		"glide": "Liito",
		"turn": "Vakaus",
		"fade": "Feidi"
	},
	"stabilityPresets": {
		"understable": "US",
		"neutral": "Neutraali",
		"overstable": "OS"
	},
	"conditionSlider": {
		"beat": "Rähjäinen",
		"likeNew": "Kuin uusi"
	},
	"flightFilter": {
		"stability": "Vakaus"
	},
	"discModelFilter": {
		"searchPlaceholder": "Hae kiekkomallia...",
		"noResults": "Kiekkomalleja ei löytynyt.",
		"selected_one": "{{count}} valittu",
		"selected_other": "{{count}} valittu"
	},
	"activePills": {
		"search": "Haku:",
		"condition": "Kunto",
		"manufacturer_one": "valmistaja",
		"manufacturer_other": "valmistajaa",
		"discModel_one": "kiekkomalli",
		"discModel_other": "kiekkomallia"
	}
}
